import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let cleanupExample = `tmpdir=$(mktemp -d)

cleanup() {
    echo "cleaning up $tmpdir"
    rm -rf "$tmpdir"
}
trap cleanup EXIT

# cleanup now runs no matter how the script exits:
# normal completion, an error under set -e, or Ctrl+C`

let signalExample = `trap 'echo "caught SIGINT, ignoring"' INT
trap '' TERM   # ignore SIGTERM entirely
trap - INT     # restore default SIGINT behavior`

export default function TrapsAndSignals() {
    return (
        <div className={globalStyles.article}>
            <h1>Traps & signal handling</h1>
            <p><code>trap</code> registers a command (or function) to run when the shell receives a signal or
                reaches certain events — the most common use is guaranteed cleanup.</p>

            <h3>Cleanup on exit (EXIT trap)</h3>
            <p><code>EXIT</code> is a pseudo-signal that fires whenever the script ends, whatever the
                reason — a natural place for temp-file cleanup.</p>
            <SyntaxHighlighter
                children={cleanupExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Handling real signals</h3>
            <SyntaxHighlighter
                children={signalExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Signal</th>
                        <th>Typical trigger</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>EXIT</code></td>
                        <td>Script ends (bash pseudo-signal, not a real one)</td>
                    </tr>
                    <tr>
                        <td><code>INT</code></td>
                        <td>Ctrl+C</td>
                    </tr>
                    <tr>
                        <td><code>TERM</code></td>
                        <td>Default signal sent by <code>kill</code></td>
                    </tr>
                    <tr>
                        <td><code>HUP</code></td>
                        <td>Terminal closed / controlling process exited</td>
                    </tr>
                    <tr>
                        <td><code>ERR</code></td>
                        <td>Any command exits non-zero (fires alongside <code>set -e</code>)</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
